import React, {Fragment} from 'react';  
import TopHeader from '../components/header';
import OfficeLocationPage from './../views/officelocationpage';
import ProjectDetailpage from './../views/projectdetailpage';  
import ProjectDetailPagepage from './../views/projectdetailpagepm'; 
import ProjectDetailAddpage from './../views/projectdetailaddpage'; 
import ProjectDetailEditpage from './../views/projectdetaileditpage'; 
import ProjectManagerpage from './../views/projectmanagerpage'; 
import Regokasbox from './../views/regokasbox';  
import OkasAssignedBox from '../distributorHome/view/okasAssignedBox';
import OkasUnassignedBox from '../distributorHome/view/okasUnassignedBox';
import MemberLicenseView from './../views/memberlicenseview';  
import MemberLicenseDistributor from '../distributorHome/view/memberlicence';
import DistributorHelpPage from '../distributorHome/view/distributorHelpPage';
import Supportpage from './../views/supportpage'; 
import Supportpage2 from './../views/supportpage'; 
import RemoteAccess from './RemoteAccess';
import RemoteAccess2 from './RemoteAccess2';
import Helppage from './../views/helppage'; 
import DesignHelppage from './../views/design-helppage'; 
import Chatpage from './../views/chatpage';  
import Regokasboxunassigned from './../views/regokasboxunassignedpage'; 
import Regokasboxassigned from './../views/regokasboxassignedpage';
import SystemIntegratorAdd from '../distributorHome/view/systemIntegratorAdd';
import TopHeaderNew from '../distributorHome/header';
import DistributorSubscription from '../distributorHome/view/distributorsubscription';
import OkasInventory from '../distributorHome/view/okasInventory';
// import AssignOkas from './assignOkas';
import AssignOkasBox from '../distributorHome/view/assignOkasBox';
import NotificationSeeMore from '../views/notificationSeeMore';
import KnowledgeBank from '../views/knowledgeBank';
import KnowledgeBank2 from '../views/knowledgeBank';
import WhatsNew from '../views/whatsNew';
import WhatsNew2 from '../views/whatsNew';
import Video2 from '../views/video';
import Video from '../views/video';
import UpcommingEvents from '../views/upcommingEvents';
import UpcommingEvents2 from '../views/upcommingEvents';
import UserProfile from '../views/UserProfile';
import UserProfile2 from '../views/UserProfile';
import Users from '../views/usersPage';
import Users2 from '../views/usersPage';
import UserRoles from '../views/userRoles';
import UserRoles2 from '../views/userRoles';
import UserTreeChart from '../views/UserTreeChart';
import UserTreeChart2 from '../views/UserTreeChart';
import UserMarketPlace from '../views/marketPlace';
import UserMarketPlace2 from '../views/marketPlace';


const PagePrivate = ({children}) => {
       return (
       <Fragment>
               <TopHeader />
               {children}
       </Fragment>
       );
   }

   const PagePrivateNew = ({children}) => {
    return (
    <Fragment>
            <TopHeaderNew />
            {children}
    </Fragment>
    );
}


export const OfficeLocation = () =>
 <PagePrivate >
   <OfficeLocationPage/>
 </PagePrivate>

export const ProjectDetail = () =>
<PagePrivate >
  <ProjectDetailpage/>
</PagePrivate>

export const ProjectDetailPage = () =>
<PagePrivate >
  <ProjectDetailPagepage/>
</PagePrivate>

export const ProjectDetailAdd = () =>
<PagePrivate >
  <ProjectDetailAddpage/>
</PagePrivate>
export const ProjectDetailEdit = () =>
<PagePrivate >
  <ProjectDetailEditpage/>
</PagePrivate>

export const ProjectManager = () =>
<PagePrivate >
  <ProjectManagerpage/>
</PagePrivate>

export const SystemIntegratorAddPage = () =>
<PagePrivateNew >
  <SystemIntegratorAdd/>
</PagePrivateNew>

export const DistributorSubscriptionPage = () =>
<PagePrivateNew >
  <DistributorSubscription/>
</PagePrivateNew>

export const DistributorHelpPage1 = () =>
<PagePrivateNew >
  <DistributorHelpPage/>
</PagePrivateNew>

export const OkasInventoryPage = () =>
<PagePrivateNew >
  <OkasInventory/>
</PagePrivateNew>

export const Regokas = () =>
<PagePrivate >
  <Regokasbox/>
</PagePrivate>

export const NotificationSeeMorepage = () =>
  <PagePrivate >
    <NotificationSeeMore/>
  </PagePrivate>

export const UserProfilepage = () =>
  <PagePrivateNew >
    <UserProfile/>
  </PagePrivateNew>


export const UserProfilepage2 = () =>
  <PagePrivate >
    <UserProfile2/>
  </PagePrivate>



export const UserRolespage = () =>
  <PagePrivateNew >
    <UserRoles/>
  </PagePrivateNew>


export const UserRolespage2 = () =>
  <PagePrivate >
    <UserRoles2/>
  </PagePrivate>


export const UserMarketPlacePage = () =>
  <PagePrivateNew >
    <UserMarketPlace/>
  </PagePrivateNew>


export const UserMarketPlacePage2 = () =>
  <PagePrivate >
    <UserMarketPlace2/>
  </PagePrivate>

export const UserTreeChartpage = () =>
  <PagePrivateNew >
    <UserTreeChart/>
  </PagePrivateNew>


export const UserTreeChartpage2 = () =>
  <PagePrivate >
    <UserTreeChart2/>
  </PagePrivate>



export const KnowledgeBankpage = () =>
  <PagePrivateNew >
    <KnowledgeBank/>
  </PagePrivateNew>

export const KnowledgeBankpage2 = () =>

<PagePrivate >
<KnowledgeBank2/>
</PagePrivate>


export const Userpage = () =>
  <PagePrivateNew >
    <Users/>
  </PagePrivateNew>


export const Userpage2 = () =>

  <PagePrivate >
  <Users2/>
  </PagePrivate>

export const UpcommingEventsPage = () =>
  <PagePrivateNew >
    <UpcommingEvents/>
  </PagePrivateNew>

export const UpcommingEventsPage2 = () =>
  <PagePrivate >
    <UpcommingEvents2/>
  </PagePrivate>

export const VideoPage = () =>
  <PagePrivateNew >
    <Video/>
  </PagePrivateNew>

export const VideoPage2 = () =>
  <PagePrivate >
    <Video2/>
  </PagePrivate>

export const WhatsNewPage = () =>
  <PagePrivateNew >
    <WhatsNew/>
  </PagePrivateNew>

export const WhatsNewPage2 = () =>
  <PagePrivate >
    <WhatsNew2/>
  </PagePrivate>

export const AssignOkasBoxPage = () =>
<PagePrivateNew >
  <AssignOkasBox/>
</PagePrivateNew>

export const OkasAssignedBoxPage = () =>
<PagePrivateNew >
  <OkasAssignedBox/>
</PagePrivateNew>

export const OkasUnassignedBoxPage = () =>
<PagePrivateNew >
  <OkasUnassignedBox/>
</PagePrivateNew>


export const MemberLicenseDistributorPage = () =>
<PagePrivateNew >
  <MemberLicenseDistributor/>
</PagePrivateNew>

export const MemberLicense = () =>
<PagePrivate >
  <MemberLicenseView/>
</PagePrivate>

export const Regokasassigned = () =>
<PagePrivate >
  <Regokasboxassigned/>
</PagePrivate>

export const Regokasunassigned = () =>
<PagePrivate >
  <Regokasboxunassigned/>
</PagePrivate>

export const Support2 = () =>
  <PagePrivateNew >
    <Supportpage2/>
  </PagePrivateNew>
 
export const Support = () =>
<PagePrivate >
  <Supportpage/>
</PagePrivate>

export const RemoteAccessPage = () =>
  <PagePrivate >
    <RemoteAccess/>
  </PagePrivate>

export const RemoteAccessPage2 = () =>
  <PagePrivateNew >
    <RemoteAccess2/>
  </PagePrivateNew>

export const Help = () =>
<PagePrivate >
  <Helppage/>
</PagePrivate>

export const DesignHelp = () =>
<PagePrivate >
  <DesignHelppage/>
</PagePrivate>

export const Chat = () =>
<PagePrivate >
  <Chatpage/>
</PagePrivate> 